import { DocumentType } from '@iota/iota-management-portal-v4-client';
import { DocumentDescriptionEntity } from 'src/app/store/entity-models';

export enum CompanyDocumentLabel {
    ASSET_INH_UPLOAD = 'ASSET_INH_UPLOAD',
    ASSET_USER_UPLOAD = 'ASSET_USER_UPLOAD',

    UNREAD = 'UNREAD',

    // Legacy
    REPORTING_ACCOUNTING = 'REPORTING_ACCOUNTING'
}

export type DocumentTypeKey = 'CON' | 'INV' | 'SMT' | 'HWP';
export const DocumentTypeLabels: Record<DocumentType, string> = {
    CONTRACT: $localize`Contract`,
    INVOICE: $localize`Invoice`,
    STATEMENT: $localize`Statement`,
    HEALTHY_WORKPLACE_REPORT: $localize`Healthy Workplace Report`
};
export const DocumentTypeKeys: Record<DocumentType, DocumentTypeKey> = {
    CONTRACT: 'CON',
    INVOICE: 'INV',
    STATEMENT: 'SMT',
    HEALTHY_WORKPLACE_REPORT: 'HWP'
};
export const DocumentTypeKeyToDocumentType: Record<DocumentTypeKey, DocumentType> = {
    CON: DocumentType.CONTRACT,
    INV: DocumentType.INVOICE,
    SMT: DocumentType.STATEMENT,
    HWP: DocumentType.HEALTHY_WORKPLACE_REPORT
};

// For naming convention see HEALTH-251
// RegExp-Explanation:
// 1. group: CompanyNumber and optional 4-digit office-number (e.g. "DEF20210205-0001")
// with a non-capturing group for the optional 4-digit office-number
// 2. group: Document-Type-key (e.g. "CON")
// 3. group: File-date in ISO-format (e.g. "2023-05-31")
// 4. group: Incremental 4-digit-counter, starts with "0000" each day
// 5. group: File extension
export const COMPANY_DOCUMENT_NAME_REGEX = new RegExp(/^([a-zA-Z0-9]+(?:-\d{4})?)_([A-Z]+)_(\d{4}-\d{2}-\d{2})_(\d{4})\.(.*)/);

export const DocumentDescriptionEntityKeyLabels: Required<{ [K in keyof DocumentDescriptionEntity]: string }> = {
    bucket: '',
    checksum: '',
    businessPartnerNumber: $localize`Company-office-number`,
    contentType: $localize`File format`,
    creationBy: $localize`Creator`,
    creationById: '',
    creationDateTime: $localize`Upload date`,
    documentDescriptionId: '',
    documentId: '',
    documentType: $localize`Document type`,
    documentTypeLabel: $localize`Document type`,
    eTag: '',
    fileDate: $localize`Date`,
    fileDateString: '',
    key: '',
    labels: $localize`Labels`,
    modificationBy: '',
    modificationById: '',
    modificationDateTime: $localize`Change date`,
    name: $localize`File name`,
    numberCount: '',
    officeName: $localize`Office`,
    parentSkId: '',
    size: $localize`File size`,
    skId: '',
    url: '',
    validFrom: '',
    validTo: '',
    fileType: $localize`File format`,
    formattedBytes: ''
};

export const COMPANY_DOCUMENT_DATE_PROPERTIES: (keyof DocumentDescriptionEntity)[] = [
    'fileDate',
    'creationDateTime',
    'modificationDateTime'
];
